module.exports = __webpack_public_path__ + "media/images/athletes/2351-7025bbc0e38018cf94a3d40729254938.png";